import { render, staticRenderFns } from "./ModalBarTabOpen.vue?vue&type=template&id=00d4e064&scoped=true&"
import script from "./ModalBarTabOpen.vue?vue&type=script&lang=js&"
export * from "./ModalBarTabOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d4e064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d4e064')) {
      api.createRecord('00d4e064', component.options)
    } else {
      api.reload('00d4e064', component.options)
    }
    module.hot.accept("./ModalBarTabOpen.vue?vue&type=template&id=00d4e064&scoped=true&", function () {
      api.rerender('00d4e064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-bar/components/modals/ModalBarTabOpen.vue"
export default component.exports